import { formatarData, formatarMoeda } from "../../../utils/solicitacoes/formatters";
import Campo from "../Shared/Campo";

// Dados acumulados do processo — sempre visível, independentemente da etapa atual. Processo único
// que reúne Promoção (cargo/salário), Transferência (filial) e Enquadramento (escala/turno) — só
// mostra a seção de cada tipo de mudança que a solicitação de fato incluiu.
export default function DetalhePromocao({ detalheProcesso }) {
    if (!detalheProcesso) return null;

    return (
        <div className="bg-card border border-border rounded-lg shadow-card p-4 md:p-6 flex flex-col gap-4">
            <div>
                <h2 className="font-display text-base font-semibold text-foreground mb-4">Dados do Colaborador</h2>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <Campo label="Filial" valor={detalheProcesso.unidadeNome} />
                    <div className="col-span-3">
                    <Campo label="Funcionário" valor={detalheProcesso.funcionarioNome} />

                    </div>
                </div>
            </div>

            {(detalheProcesso.incluiPromocao || detalheProcesso.incluiEnquadramento) && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Cargo</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                        <Campo label="Cargo atual" valor={detalheProcesso.cargoAtual} />
                        <Campo label="Cargo proposto" valor={detalheProcesso.cargoProposto} />
                    </div>
                </div>
            )}

            {detalheProcesso.incluiPromocao && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Solicitação de Promoção</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm mb-3">
                        <Campo label="Data prevista para mudança" valor={formatarData(detalheProcesso.dataPrevistaMudanca)} />
                        <Campo label="Salário atual" valor={formatarMoeda(detalheProcesso.salarioAtual)} />
                        <Campo label="Salário proposto" valor={formatarMoeda(detalheProcesso.salarioProposto)} />
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                        <Campo label="Setor atual" valor={detalheProcesso.setorAtual} />
                        <Campo label="Muda de setor" valor={detalheProcesso.mudaDeSetor ? "Sim" : "Não"} />
                        {detalheProcesso.mudaDeSetor && <Campo label="Setor proposto" valor={detalheProcesso.setorProposto} />}
                    </div>
                </div>
            )}

            {detalheProcesso.incluiTransferencia && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Solicitação de Transferência</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                        <Campo label="Filial atual" valor={detalheProcesso.unidadeNome} />
                        <Campo label="Filial de destino" valor={detalheProcesso.filialPropostaNome} />
                    </div>
                </div>
            )}

            {detalheProcesso.incluiEnquadramento && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Enquadramento</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                        <Campo label="Escala atual" valor={detalheProcesso.escalaAtual} />
                        <Campo label="Escala proposta" valor={detalheProcesso.escalaProposta} />
                    </div>
                </div>
            )}

            {detalheProcesso.beneficios && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Benefícios</h3>
                    <p className="text-sm text-foreground whitespace-pre-wrap">{detalheProcesso.beneficios}</p>
                </div>
            )}

            <div>
                <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Justificativa</h3>
                <p className="text-sm text-foreground whitespace-pre-wrap">{detalheProcesso.justificativa}</p>
            </div>

            {detalheProcesso.comentarioAprovacaoGestor && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Comentário do Gestor</h3>
                    <p className="text-sm text-foreground whitespace-pre-wrap">{detalheProcesso.comentarioAprovacaoGestor}</p>
                </div>
            )}

            {detalheProcesso.justificativaAnalise && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Justificativa da Análise (RH)</h3>
                    <p className="text-sm text-foreground whitespace-pre-wrap">{detalheProcesso.justificativaAnalise}</p>
                </div>
            )}
        </div>
    );
}

